import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import Beyond from '../components/section/beyond_academics';
import Career from '../components/section/career';
import Cbse from '../components/section/cbse';
import Infrastructure from '../components/section/infrastructure';
import LifeAtInnovera from '../components/section/life_at_innovera';
import Team from '../components/section/team';
  import config from '../constant';


class TeamMain extends Component {
    componentDidMount(){
        document.title = "Team | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <Team/>
             <Footer/>


        </div>
    );

}
    }
export default TeamMain;